<template>
    <Modal class-name="scrollable vertical-center-modal" title="Nueva Competencia" v-model="show" :footer-hide="true" :scrollable="true">
        <Form style="width: 100%" ref="planForm" :model="competence" :rules="ruleInline">
            <h3 style="text-align: center">{{ name }}</h3>
            <br>
            <Row :gutter="16">
                <i-col span="24">
                    <FormItem label="Competencia" prop="name">
                        <Input type="textarea" v-model="competence.name" placeholder="" :rows="5"/>
                    </FormItem>
                </i-col>
                <i-col span="24">
                    <Button style="margin-top: 25px" size="large" long type="primary" :loading="loading" @click="save">Agregar</Button>
                </i-col>
            </Row>
        </Form>
    </Modal>
</template>

<script>
    export default {
        data(){
            return {
                show: false,
                name: '',
                competence: {
                    name: "",
                    category: '',
                },
                loading: false,
                ruleInline: {
                    name: [
                        { required: true, message: 'Nombre es requerido', trigger: 'change' }
                    ],
                },
            }
        },
        methods: {
            save(){
                this.$refs.planForm.validate(valid => {

                    if(valid){
                        this.loading = true
                        window.axios.post(this.$root.API_URL + '/evaluation/competences/create-special', { ...this.competence })
                        .then(response => {
                            if(response.data.success){
                                window.EventBus.$emit('competences--add-special-competence', response.data.competence)
                                this.show = false
                                this.loading = false
                                this.clear()
                            }
                        })
                        .catch(() => {
                            this.loading = false
                            this.$Message.error('Hubo un problema, no pudimos completar esta acción');
                        })
                    }
                })
            },
            clear(){
                this.competence = {
                    name: "",
                    category: '',
                }
            }
        },
        mounted(){
            window.EventBus.$on('competences--create-special-popup', (data) => {
                this.name = data.name
                this.competence.category = data.category
                this.show = true
            })
        }
    }
</script>